import { defineComponent as _defineComponent } from 'vue'
import FormLayout from '@/components/common/FormLayout.vue'
import SignaturePad from '@/components/common/SignaturePad.vue'
import { computed, ref } from 'vue'
import { useAddSignatureMutation } from '../../api/signature'
import { getJobLineItemsQuery } from '@/api/jobs'
import JobSignature, { SignatureMetadataJson } from '../../models/job-signature'
import { useCurrentUser } from '@/common/useCurrentUser'
import { useJobBottomSheetStatesStore } from '@/components/jobs/jobBottomSheetStatesStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'JobSignatureForm',
  props: {
    jobId: null
  },
  emits: ["dismiss", "signature-added"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'dismiss'): void
  (e: 'signature-added', signature: JobSignature): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  jobId: string
}

const form = ref()
const signature = ref()
const currentUser = useCurrentUser()





const jobBottomSheetStatesStore = useJobBottomSheetStatesStore()

const {
  mutateAsync: addSignature,
  isLoading: addingSignature,
  isError: addSignatureError,
} = useAddSignatureMutation()

const { data: lineItems } = getJobLineItemsQuery(props.jobId)

const hasChanges = computed(
  () => signature.value !== null && signature.value !== undefined
)

const buildMetadata = computed<SignatureMetadataJson>(() => {
  const items: any[] = []

  lineItems.value?.forEach((li) => {
    items.push({ [li.name]: li.quantity })
  })

  return { items_when_signed: items }
})

async function save() {
  if (!form.value.isValid()) return
  const response = await addSignature({
    jobId: props.jobId,
    signedAt: new Date().toISOString(),
    name: currentUser.value.name,
    email: currentUser.value.email,
    signatureMetadata: buildMetadata.value,
    signatureFile: signature.value,
  })
  if (!addSignatureError.value && response) {
    emit('signature-added', response)
    dismiss()
  }
}

function handleSignatureInput(data: File) {
  signature.value = data
}

function clear() {
  signature.value = null
}

function dismiss() {
  jobBottomSheetStatesStore.setJobBottomSheetStates({
    isSignatureBottomSheetVisible: false,
  })
  emit('dismiss')
}

return { __sfc: true,form, signature, currentUser, props, emit, jobBottomSheetStatesStore, addSignature, addingSignature, addSignatureError, lineItems, hasChanges, buildMetadata, save, handleSignatureInput, clear, dismiss, FormLayout, SignaturePad }
}

})